import { useEffect, useState } from 'react';
import { useDsnListLocalStorage } from './useDsnListLocalStorage';
import { DateRangeValue } from '../utils/dateHelpers';

export interface DsnFilterStateProps {
  selectedUserIds: string[];
  setSelectedUserIds: (ids: string[]) => void;
  isTest: boolean;
  setIsTest: (isTest: boolean) => void;
  selectedStatus: string | null;
  setSelectedStatus: (status: string | null) => void;
  selectedNatures: string[];
  setSelectedNatures: (natures: string[]) => void;
  searchTerm?: string;
  setSearchTerm: (term: string) => void;

  // Date range
  dateRangeValue: DateRangeValue;
  setDateRangeValue: (value: DateRangeValue) => void;

  // Pagination
  pageSize: number;
  setPageSize: (size: number) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

export const useDsnFilterState = (): DsnFilterStateProps => {
  // Accès au localStorage
  const {
    localSelectedStatus,
    setLocalSelectedStatus,
    localSelectedNatures,
    setLocalSelectedNatures,
    localSelectedUserIds,
    setLocalSelectedUserIds,
    localIsTest,
    setLocalIsTest,
    searchValue: localSearchValue,
    setSearchValue: setLocalSearchValue,
    localPageSize,
    setLocalPageSize,
    localCurrentPage,
    setLocalCurrentPage,
    dateRangeValue: localDateRange,
    setDateRangeValue: setLocalDateRange,
  } = useDsnListLocalStorage();

  const [selectedUserIds, setSelectedUserIds] = useState<string[]>(localSelectedUserIds || []);
  const [isTest, setIsTest] = useState<boolean>(localIsTest);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(localSelectedStatus);
  const [selectedNatures, setSelectedNatures] = useState<string[]>(localSelectedNatures);
  const [searchTerm, setSearchTerm] = useState<string>(localSearchValue);

  const [pageSize, setPageSize] = useState<number>(localPageSize);
  const [currentPage, setCurrentPage] = useState<number>(localCurrentPage);

  const [dateRangeValue, setDateRangeValue] = useState<DateRangeValue>(localDateRange);

  useEffect(() => {
    setLocalIsTest(isTest);
    setLocalSelectedStatus(selectedStatus);
    setLocalSelectedNatures(selectedNatures);
    setLocalSelectedUserIds(selectedUserIds);
    setLocalSearchValue(searchTerm);
    setLocalPageSize(pageSize);
    setLocalCurrentPage(currentPage);
    setLocalDateRange(dateRangeValue);
  }, [
    isTest,
    selectedStatus,
    selectedNatures,
    selectedUserIds,
    searchTerm,
    pageSize,
    currentPage,
    dateRangeValue,
    setLocalIsTest,
    setLocalSelectedStatus,
    setLocalSelectedNatures,
    setLocalSelectedUserIds,
    setLocalSearchValue,
    setLocalPageSize,
    setLocalCurrentPage,
    setLocalDateRange,
  ]);

  return {
    selectedUserIds,
    setSelectedUserIds,
    isTest,
    setIsTest,
    selectedStatus,
    setSelectedStatus,
    selectedNatures,
    setSelectedNatures,
    searchTerm,
    setSearchTerm,

    // Date range
    dateRangeValue,
    setDateRangeValue,

    // Pagination
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
  };
};
